import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProjetsView from '../views/ProjetsView.vue'
import MesCompetences from '../views/MesCompetences.vue'
import SavoirsFaire from '../views/SavoirsFaire.vue'
import SavoirsEtre from '../views/SavoirsEtre.vue'
import FrontEnd from '@/views/FrontEnd.vue'
import BackEnd from '@/views/BackEnd.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/projets',
    name: 'projets',
    component: ProjetsView
  },
  {
    path: '/mescompetences',
    name: 'mescompetences',
    component: MesCompetences
  },
  {
    path: '/savoirsfaire',
    name: 'savoirsfaire',
    component: SavoirsFaire
  },
  {
    path: '/savoirsetre',
    name: 'savoirsetre',
    component: SavoirsEtre
  },
  {
    path: '/frontend',
    name: 'frontend',
    component: FrontEnd
  },
  {
    path: '/backend',
    name: 'backend',
    component: BackEnd
  },



]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
    
  scrollBehavior() {
    return { top: 0 }
  }

})

export default router
